import { render } from "./VendorNotesList.vue?vue&type=template&id=66086f28"
import script from "./VendorNotesList.vue?vue&type=script&lang=js"
export * from "./VendorNotesList.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__